import { useEffect } from "react";
import logger from "./Logger";
import { useMutationRegisterGuest } from "../services/api/mutations/useMutationRegisterGuest";
import { useMutationLoginGuest } from "../services/api/mutations/useMutationLoginGuest";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useQueryPlace } from "../services/api/queries/useQueryPlace";
import { ICardapioAppState } from "../redux/RootReducer";

function useGuestLogin(){
  const { mutate: registerGuest } = useMutationRegisterGuest();
  const { mutate: loginGuest } = useMutationLoginGuest();
  const [searchParams] = useSearchParams();
  const placeId = searchParams.get("place_id");

  const apiPlace = useQueryPlace(Number(placeId) ? Number(placeId) : 445057);
  // Verify User in Redux and LocalStorage
  let idGuest = localStorage.getItem("idGuest");
  const loginInfo = useSelector((state: ICardapioAppState) => state?.loginInfo);

  useEffect(() => {
    logger.log('inside useEffect about login')
    logger.log('loginInfo: ', loginInfo)

    if (!loginInfo) {
      logger.log('if (!loginInfo) {')

      if (localStorage.getItem("loginInfo") === null) {

        logger.log('localStorage.getItem("loginInfo") === null')
        if (idGuest === null) {
          logger.log('idGuest === null')
          logger.log('apiPlace', apiPlace)
          logger.log('apiPlace.data?.data?.app_id: ', apiPlace.data?.data?.app_id)

          if (apiPlace.data?.data?.app_id) {
            logger.log('apiPlace.data?.data?.app_id: ', apiPlace.data?.data?.app_id)

            registerGuest(apiPlace.data?.data?.app_id);
          }
        } else {
          logger.log('else: will try loginGuest')

          loginGuest({
            id: Number(idGuest),
            guest_user: true,
            password: "220309",
          });
        }
      }
    }
  }, [idGuest, loginInfo, apiPlace.data?.data?.app_id]);
}

export default useGuestLogin